import { Box, Typography } from '@mui/material';
import Link from 'next/link';

const NoticiaFuente = ({ noticia, ...props }) => {
    const fuenteTexto = noticia?.sourceText;
    const fuenteUrl = noticia?.sourceUrl;

    if (!fuenteTexto || !fuenteUrl) return null;

    return (
        <Box display="flex" gap={0.25} {...props} alignItems="center">
            <Typography fontSize={14}>Fuente:</Typography>
            <Link nofollow rel="noopener noreferrer" href={fuenteUrl} target="_blank" prefetch={false}>
                <Typography sx={{ color: 'primary.main', fontSize: '14px' }} component={'span'}>
                    {fuenteTexto}
                </Typography>
            </Link>
        </Box>
    );
};

export default NoticiaFuente;
